__turbopack_context__.v({
  "config-skeleton": "loading-product-configuration-module-scss-module__EqEJNW__config-skeleton",
  "image-container": "loading-product-configuration-module-scss-module__EqEJNW__image-container",
  "order-details-skeleton": "loading-product-configuration-module-scss-module__EqEJNW__order-details-skeleton",
  "section": "loading-product-configuration-module-scss-module__EqEJNW__section",
  "skeleton-container": "loading-product-configuration-module-scss-module__EqEJNW__skeleton-container",
});
